import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import awsLogo from "./aws_logo.png"

import { Grid, CircularProgress, Typography, Button, TextField, Fade,Link, Box, Tabs, Tab } from "@material-ui/core";

// styles
import useStyles from "./styleLadp";


// store
import * as actions from "../../store/actions/actionIndex";
import { updateObject } from "../../helpers/utility";
import { checkLoginValidity } from "../../helpers/checkValidation";
import RmlLogin from "./RmlLogin";
import CzLogin from "./CzLogin";
import PasswordReset from "../../components/Modal/PasswordReset";
import { ToastContainer } from "react-toastify";
import { withStyles, makeStyles } from "@material-ui/core/styles";


const CustomTab = withStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "auto !important",
    padding: "6px",
  [theme.breakpoints.down("xs")]: {
          padding: '4px 7px',
      },
  },
  selected: {
    backgroundColor: "#fff",
    color: "#536DFE",
  },
  wrapper: {
    fontSize: '16px',
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down("xs")]: {
      fontSize: '14px',
      fontWeight: 500,
      },
  },
}))(Tab);

function LDAPLogin(props) {
    const data = window.Configs.var1;
    const [reset, setRest] = useState(false)
    //console.log("-----------Amit----------"+data);
    var classes = useStyles();
    const [valid, setValid] = useState({ isValid: true, errorMsg: "" });
    const [login, setLogin] = useState(false);
    const [open, setOpen] = useState(false);
     const [tabIndex, setTabIndex] = useState(0);
     const [failedReason, setFailedReason] = useState("")
    const [ldapControl, setLdapControl] = useState({
        ldap_user:  {
            value: "",
        },
        ldap_password: {
            value: "",
        },
    })
    const [controls, setControls] = useState({
        email: {
            value: "",
        },
        password: {
            value: "",
        },
    });

    const inputChangedHandler = (event, controlName) => {
        setRest(false)
        setValid(checkLoginValidity(event.target.value, controlName));
       if(tabIndex === 0){
       const updatedControls = updateObject(controls, {
            [controlName]: updateObject(controls[controlName], {
                value: event.target.value,
            }),
        });
        setControls(updatedControls);
       }
    const updatedControls = updateObject(ldapControl, {
            [controlName]: updateObject(ldapControl[controlName], {
                value: event.target.value,
            }),
        });
        setLdapControl(updatedControls)
    };

    const checkKeycode = React.useCallback(
        (e) => {
            let keycode;
            try {
                if (window.event) keycode = window.event.keyCode;
                else if (e) keycode = e.which;

                if (keycode === 13 && valid.isValid) {
                    if(tabIndex === 0){
                        props.onAgentValidate(controls.email.value)
                    setRest(true)
                    }
                    else{
                        getLdapAuthenticate();
                    }
                }
                return true;
            } catch (e) { }
        },
        [valid, controls, props]
    );

    React.useEffect(() => {
        document.onkeydown = checkKeycode;
        return () => {
            document.onkeydown = null;
        };
    }, [checkKeycode]);

 const submitHandler = () => {
  console.log(tabIndex);

  if (tabIndex === 0) {
    props.onAgentValidate(controls.email.value);
  } else {
    getLdapAuthenticate();
  }

  setRest(true);
};

useEffect(() =>{

        if((props.responseCode === "1" ||props.responseCode === "2") && reset === true){
        setLogin(true);
        props.onAuth(controls.email.value, controls.password.value, "", "login",1);
        }
    },[props.responseCode, reset])

    const handleClose = () =>{
        setOpen(false);
        setRest(false);
        
    }
    const loginHandler = (action) => {
        //event.preventDefault();
        if (action === "no") {
            setControls({
                email: {
                    value: "",
                },
                password: {
                    value: "",
                },
            });
            props.onAuth(controls.email.value, controls.password.value, "", "newlogin",1);
        } else if (action === "yes") {
            props.onAuth(controls.email.value, controls.password.value, "", "relogin",1);
        }
    };
useEffect(()=>{
    if(props.isExpired === true && reset === true){
        setOpen(true)
    }
},[props.isExpired, reset])
    let d = new Date();
    let currentYear = d.getFullYear();

    const awsLoginHandler = () => {
  const awsLoginUrl = window?.Configs?.sso_login_url;
  if (awsLoginUrl) {
    window.location.href = awsLoginUrl;
  } else {
    console.error("AWS login URL is not defined in window.Configs");
  }
};

 const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  // to authenticate ldap user
 const getLdapAuthenticate = async () => {
  fetch(window.Configs.ldap_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      transaction_id: "LDAP_AGENT_LOGIN",
      ldap_user: ldapControl.ldap_user.value,
      ldap_password: ldapControl.ldap_password.value,
    }),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("LDAP authentication failed");
      }
      return res.json();
    })
    .then((data) => {
      console.log("LDAP Auth Success:", data);

      if (data.status === "SUCCESS") {
        console.log(data.data)
        setControls((prev) => ({
          ...prev,
          email: { value: data.data.agent_id },
          password: { value: data.data.agent_secret },
        }));

        props.onAgentValidate(data.data.agent_id);
      }
      else{
      setFailedReason(data.failure_reason)
      }
    })
    .catch((error) => {
      console.error("LDAP Auth Error:", error);
      setFailedReason("Request Error, Please contact with Admin.")
    });
};



    // 🔹 Reset the inactive tab
  useEffect(() => {
    if (tabIndex === 0) {
      setLdapControl({
                ldap_user: {
                    value: "",
                },
                ldap_password: {
                    value: "",
                },
            });
            setFailedReason( "")
    } else {
        setControls({
                email: {
                    value: "",
                },
                password: {
                    value: "",
                },
            });
       
    }
  }, [tabIndex]);

    return (
        <>
        <ToastContainer />
        
            <Grid container className={classes.container}>
                    {
                 window.Configs.rml_login === true ? (
                 <RmlLogin />
                      ) : (
                 <CzLogin />
                         )
                    }
                <div className={classes.formContainer}>
                    <div className={classes.switchToAP}>
                        <Link href={data} variant="button" underline="hover" size="large" style={{ flex: "auto",textAlign:'center' }}>Switch to old C-Zentrix Agent Panel</Link>
                    </div>	
                    <div className={classes.mainContainer}>	
                    <Typography variant="h1" className={classes.greeting}>
                        Welcome, User
                    </Typography>
                    <Typography variant ="p" className={classes.signOption}>
                        Choose how you’d like to sign in.
                    </Typography>
                    {/* Tabs View*/}
                    <Tabs
                            value={tabIndex}
                            onChange={handleTabChange}
                            aria-label="styled tabs"
                            textColor="primary"
                            
                            TabIndicatorProps={{ style: { display: 'none' } }} 
                            style={{textAlign: "center", justifyContent: "center", alignItems: "center", backgroundColor: "#f1f5f9", padding: "0 6px", margin: "10px" }}
                        >
                        <CustomTab 
                            label={
                            <Box display="flex" alignItems="center">
                                {/* <PersonOutlineIcon className={classes.tabsIcon} /> */}
                                Standard
                            </Box>
                            } 
                            wrapped 
                        />
                        <CustomTab 
                            label={
                            <Box display="flex" alignItems="center">
                                {/* <SettingsPhoneIcon className={classes.tabsIcon} /> */}
                                LDAP
                            </Box>
                            } 
                            wrapped 
                        />
                    </Tabs>
                    <div className={classes.form}>
                        <React.Fragment>
                            <h3 style={{textAlign: "left", margin: "0", fontWeight:"400", fontSize: "16px", color: "#908885"}}>{tabIndex === 0 ? "Sign in with Agent" : "LDAP sign in"}</h3>
                            {tabIndex === 0 ? 
                            <React.Fragment>
                                <TextField id="email" InputProps={{ classes: { underline: classes.textFieldUnderline, input: classes.textField, }, }} value={controls.email.value} onChange={(event) => inputChangedHandler(event, "email")} margin="normal" placeholder="Agent ID / Email Address" type="text" fullWidth /> 
                                 <TextField id="password" InputProps={{ classes: { underline: classes.textFieldUnderline, input: classes.textField, }, }} value={controls.password.value} onChange={(event) => inputChangedHandler(event, "password")} margin="normal" placeholder="Password" type="password" fullWidth />
                            </React.Fragment>
                            :
                            <React.Fragment>
                                    <TextField id="ldap_user" InputProps={{ classes: { underline: classes.textFieldUnderline, input: classes.textField, }, }} value={ldapControl.ldap_user.value} onChange={(event) => inputChangedHandler(event, "ldap_user")} margin="normal" placeholder="LDAP UserName" type="text" fullWidth /> 
                                    <TextField id="ldap_password" InputProps={{ classes: { underline: classes.textFieldUnderline, input: classes.textField, }, }} value={ldapControl.ldap_password.value} onChange={(event) => inputChangedHandler(event, "ldap_password")} margin="normal" placeholder="Password" type="password" fullWidth />
                            </React.Fragment> 
                            }
                            {props.error !== "ReloginAgent" && (
                                <div className={classes.formButtons}>
                                    <Button
                                    disabled={
                                        tabIndex === 0
                                        ? !controls.email?.value || !controls.password?.value || !valid.isValid
                                        : !ldapControl.ldap_user?.value || !ldapControl.ldap_password?.value || !valid.isValid
                                    }
                                    onClick={submitHandler}
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    sx={{ flex: "auto" }}
                                    >
                                    Login
                                    {props.loading && (
                                        <CircularProgress size={26} className={classes.loginLoader} />
                                    )}
                                    </Button>

                                </div>
                            )}
                        

                             {/* AWS Login Button */}
                                {window.Configs.sso_enable_flag === 1 && (
                                    <>
                                        {/* OR separator */}
                                        <div className={classes.separator}>
                                        <span>OR continue with</span>
                                        </div>

                                        <div className={classes.formButtons}>
                                        <Button
                                            onClick={() => awsLoginHandler()}
                                            variant="outlined"
                                            size="large"
                                            className={classes.awsButton}
                                            startIcon={<img src={awsLogo} alt="AWS Logo" className={classes.awsLogo} />}
                                        >
                                            Sign in with AWS
                                        </Button>
                                        </div>
                                    </>
                                )}
 <Fade in={(props.error && login) || !valid.isValid || !!failedReason}>
  <Typography
    color="secondary"
    className={classes.errorMessage}
    style={{ marginBottom: "10px" }}
  >
    {valid.errorMsg !== ""
      ? valid.errorMsg
      : login && props.error
      ? props.error === "ReloginAgent"
        ? "Agent is already login. Do you want to create new session?"
        : props.error
      : failedReason
      ? failedReason
      : ""}
  </Typography>
</Fade>


                            {props.error === "ReloginAgent" && (
                                <>
                                    <div className={classes.formButtons}>
                                        <Button onClick={() => loginHandler("yes")} variant="contained" color="primary" size="large" style={{ flex: "auto" }}>
                                            Yes
                                            {props.loading ? <CircularProgress size={26} className={classes.loginLoader} /> : ""}
                                        </Button>
                                    </div>
                                    <div className={classes.formButtons}>
                                        <Button onClick={() => loginHandler("no")} variant="contained" color="primary" size="large" style={{ flex: "auto" }}>
                                            No
                                            {props.loading ? <CircularProgress size={26} className={classes.loginLoader} /> : ""}
                                        </Button>
                                    </div>
                                </>
                            )}
                        </React.Fragment>
                        
                    </div>
                    </div>	
                    
                    <Typography color="primary" className={classes.copyright}>
                        © {currentYear} . All rights reserved.
                    </Typography>
                </div>
                {props.isExpired && (
                <PasswordReset agentId={controls.email.value} soonExpired={false} open={open} handleClose={handleClose} />
            )}
            </Grid>
            </>
    );
}

const mapStateToProps = (state) => {
    return {
        loading: state.agentData.loading,
        error: state.agentData.error,
        isAuthenticated: state.agentData.loggedIn,
        loginWait: state.agentData.loginWait,
        loginType: state.agentData.loginType,
        responseCode: state.resetData.responseCode,
        reason: state.resetData.reason,
        isExpired: state.resetData.isExpired,
        restError: state.resetData.error,
        //authRedirectPath: state.agentData.authRedirectPath,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    onAgentValidate: (email) => dispatch(actions.checkValidateAgent(email)),
    onAuth: (email, password, extension, action, session_flag) => dispatch(actions.agentLogin(email, password, extension, action, session_flag)),
        //onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath('/')),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LDAPLogin);
